import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../../components/footer/Footer.component";
import Header from "../../components/header/Header.component";

const excludePaths = ["/login", "/signup", "/forgot-password", "/reset-password", "/verify-account", "/account-lock"];

const LayoutContainer = () => {
    const location = useLocation();

    React.useLayoutEffect(() => {
        document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return (
        <>
            {!(location?.pathname.includes("/preview-document")) && <Header />}
            <Outlet />
            {!(excludePaths.includes(location.pathname) || location?.pathname.includes("/preview-document")) && <Footer />}
        </>
    )

}

export default LayoutContainer;